<template>
  <div id="password-reset-screen">
    <div class="password-wrapper pa-0">
      <!-- Main Content -->
      <div class="page-wrapper pa-0 ma-0 auth-page">
        <div class="container">
          <!-- Row -->
          <div class="table-struct full-width full-height">
            <div class="table-cell vertical-align-middle auth-form-wrap">
              <div class="auth-form ml-auto mr-auto no-float card-view pt-30 pb-30">
                <div class="row">
                  <div class="col-sm-12 col-xs-12 center-image">
                    <img class="logo" src="static/login_logo.png">
                  </div>
                  <div class="col-sm-12 col-xs-12">
                    <div class="mb-30">
                      <h6 class="text-center nonecase-font txt-grey">{{ $t('app.passwordReset.passwordResetSubTitle') }}</h6>
                    </div>
                    <div class="form-wrap">
                      <div class="form-group">
                        <label
                          class="control-label mb-10"
                          for="exampleInputEmail_2"
                        >{{ $t('app.login.userNameTitle') }}</label>
                        <base-input
                          v-model="userName"
                          :type="'text'"
                          :classNames="`form-control`"
                          :required="true"
                          :placeholder="$t('app.login.userNamePlaceholder')"
                          @keyup.enter.native="sendResetEmail"
                        />
                      </div>
                      <div class="form-group text-center">
                        <base-button
                          :title="$t('app.passwordReset.passwordResetButton')"
                          :classNames="`btn btn-orange btn-rounded`"
                          @clicked="sendResetEmail"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- /Row -->
        </div>
      </div>
      <!-- /Main Content -->
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

import BaseInput from "@/components/shared/inputs/BaseInput";
import BaseButton from "@/components/shared/buttons/BaseButton";
import Notification from "@/components/shared/notifications/Notification";

export default {
  name: "LoginScreen",
  components: {
    "base-input": BaseInput,
    "base-button": BaseButton,
    notification: Notification
  },
  data() {
    return {
      userName: "",
    };
  },
  methods: {
    ...mapActions({
      resetPasswordToken: "users/resetPasswordToken",
		}),
		sendResetEmail() {
			this.resetPasswordToken({user_name: this.userName})
        .then(response => {
          this.$eventBus.showNotification({
            notificationText: this.$t('app.notifications.resetEmailSent'),
            notificationType: "success"
          });
        })
        .catch(error => {
          this.$swal
          .fire({
            html: error[0],
            type: "error",
            showCloseButton: true,
            showCancelButton: false,
            showConfirmButton: false,
            focusConfirm: false,
          })
        });
		}
  }
};
</script>

<style lang="scss">
#password-reset-screen {
  height: 100%;
  .password-wrapper {
    height: 100%;
  }

  .center-image {
    display: flex;
    justify-content: center;
  }

  .logo {
    max-height: 205px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modules/authentication/PasswordResetScreen.vue